export default __webpack_public_path__ + "img/9d6e007d1cc10a90595b5bc99d199cbc.svg";